import { render, staticRenderFns } from "./Situation.vue?vue&type=template&id=e8085002&scoped=true&"
import script from "./Situation.vue?vue&type=script&lang=js&"
export * from "./Situation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8085002",
  null
  
)

export default component.exports